import React, { useContext, useRef, useEffect } from 'react';
import './Safety.scss';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { LanguageContext } from '../../context/LanguageContext';
import useAnalytics from '../../hooks/useAnalytics';

const Safety = () => {
    const { t } = useContext(LanguageContext);
    const { trackEvent } = useAnalytics();
    const iframeRef = useRef(null);
    const videoId = "wULLhk_20fM";
    const videoTitle = "Mona Klinik Güvenlik Videosu";
    const videoProgressTracked = useRef({
        started: false,
        quarter: false,
        half: false,
        threeQuarters: false,
        completed: false
    });

    useEffect(() => {
        // YouTube Player API'ı yükle
        const tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // YouTube Player API yüklendikten sonra
        window.onYouTubeIframeAPIReady = () => {
            const player = new window.YT.Player(iframeRef.current, {
                events: {
                    'onStateChange': (event) => {
                        // -1: unstarted, 0: ended, 1: playing, 2: paused, 3: buffering, 5: video cued
                        switch (event.data) {
                            case 1: // playing
                                if (!videoProgressTracked.current.started) {
                                    trackEvent('video_play_start', {
                                        video_id: videoId,
                                        video_title: videoTitle,
                                        source: 'safety_section'
                                    });
                                    videoProgressTracked.current.started = true;
                                }
                                
                                // İlerleme takibi için interval başlat
                                const progressInterval = setInterval(() => {
                                    if (!player) {
                                        clearInterval(progressInterval);
                                        return;
                                    }
                                    
                                    const currentTime = player.getCurrentTime();
                                    const duration = player.getDuration();
                                    const progress = (currentTime / duration) * 100;
                                    
                                    // %25 izlendi
                                    if (progress >= 25 && !videoProgressTracked.current.quarter) {
                                        trackEvent('video_play_25', {
                                            video_id: videoId,
                                            video_title: videoTitle,
                                            source: 'safety_section'
                                        });
                                        videoProgressTracked.current.quarter = true;
                                    }
                                    
                                    // %50 izlendi
                                    if (progress >= 50 && !videoProgressTracked.current.half) {
                                        trackEvent('video_play_50', {
                                            video_id: videoId,
                                            video_title: videoTitle,
                                            source: 'safety_section'
                                        });
                                        videoProgressTracked.current.half = true;
                                    }
                                    
                                    // %75 izlendi
                                    if (progress >= 75 && !videoProgressTracked.current.threeQuarters) {
                                        trackEvent('video_play_75', {
                                            video_id: videoId,
                                            video_title: videoTitle,
                                            source: 'safety_section'
                                        });
                                        videoProgressTracked.current.threeQuarters = true;
                                    }
                                    
                                    // Video durmuşsa intervali temizle
                                    if (player.getPlayerState() !== 1) {
                                        clearInterval(progressInterval);
                                    }
                                }, 1000);
                                break;
                                
                            case 0: // ended - video tamamlandı
                                if (!videoProgressTracked.current.completed) {
                                    trackEvent('video_play_complete', {
                                        video_id: videoId,
                                        video_title: videoTitle,
                                        source: 'safety_section'
                                    });
                                    videoProgressTracked.current.completed = true;
                                }
                                break;
                                
                            case 2: // paused - video duraklatıldı
                                trackEvent('video_pause', {
                                    video_id: videoId,
                                    video_title: videoTitle,
                                    source: 'safety_section'
                                });
                                break;
                                
                            default:
                                break;
                        }
                    }
                }
            });
        };

        // Cleanup
        return () => {
            delete window.onYouTubeIframeAPIReady;
        };
    }, [trackEvent]);

    return (
        <section className='safty-section pt-100 section-bg section-common pb-70' data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle 
                    subTitle={t('safety.sectionTitle')}
                    title={t('safety.title')}
                    description={t('safety.description')}
                />

                <div className="safety-video ratio ratio-16x9">
                    <iframe 
                        ref={iframeRef}
                        src="https://www.youtube.com/embed/wULLhk_20fM?enablejsapi=1" 
                        title="YouTube video player" 
                        frameBorder="0" 
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                        allowFullScreen
                    >
                    </iframe>
                </div>
            </div>
        </section>
    );
};

export default Safety;